<app-price *ngIf="english"></app-price>
<app-price-hindi *ngIf="hindi"></app-price-hindi>